import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAirtableLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 21,
	viewBox: "0 0 24 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7165 0.253477L1.76867 3.95592C1.27109 4.16185 1.27625 4.86875 1.77695 5.06721L10.7621 8.63033C11.5515 8.94343 12.4307 8.94343 13.2202 8.63033L22.2054 5.06707C22.706 4.86875 22.7114 4.16198 22.2136 3.95606L13.266 0.253342C12.4497 -0.0844472 11.5327 -0.0844472 10.7164 0.253342",
			fill: "#FCB400"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7881 10.576V19.4773C12.7881 19.9006 13.215 20.1906 13.6085 20.0346L23.6207 16.1483C23.7324 16.1041 23.8282 16.0273 23.8957 15.9279C23.9631 15.8285 23.9992 15.7112 23.9992 15.5911V6.6899C23.9992 6.26652 23.5723 5.97662 23.1787 6.13263L13.1666 10.0189C13.0549 10.0632 12.9591 10.14 12.8917 10.2393C12.8242 10.3387 12.7881 10.4559 12.7881 10.576Z",
			fill: "#18BFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4506 11.0348L7.47922 12.4695L7.17753 12.6153L0.905093 15.6208C0.507622 15.8126 0 15.5228 0 15.0811V6.72666C0 6.56685 0.0819359 6.42889 0.191817 6.32512C0.236895 6.28023 0.288036 6.24187 0.343751 6.21117C0.493514 6.12123 0.707307 6.09722 0.889085 6.16911L10.4007 9.93789C10.8842 10.1297 10.9222 10.807 10.4506 11.0348Z",
			fill: "#F82B60"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4512 11.0348L7.47979 12.4695L0.192383 6.32498C0.23747 6.28014 0.288611 6.24183 0.344317 6.21117C0.49408 6.12123 0.707873 6.09722 0.889651 6.16911L10.4013 9.93789C10.8847 10.1297 10.9227 10.807 10.4512 11.0348Z",
			fill: "black",
			fillOpacity: .25
		})
	]
});
export default SvgAirtableLogo;
